export default __webpack_public_path__ + "static/media/maternity.cb261b9d.svg";